import { spApi } from './sp';

export const marketingApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    setMarketingAttribution: builder.mutation({
      query: ({ utm_source, utm_medium, utm_campaign, utm_content, utm_term, click_ids, captured_at }) => ({
        url: '/marketing/attribution',
        method: 'POST',
        body: { utm_source, utm_medium, utm_campaign, utm_content, utm_term, click_ids, captured_at },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSetMarketingAttributionMutation } = marketingApi;